import { render, staticRenderFns } from "./OrderSuccess.vue?vue&type=template&id=a11c21ae&scoped=true&"
import script from "./OrderSuccess.vue?vue&type=script&lang=js&"
export * from "./OrderSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11c21ae",
  null
  
)

/* custom blocks */
import block0 from "./OrderSuccess.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./OrderSuccess.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports